import { IProviderReport } from 'src/types/providerReport';

export const groupProviderReportToTotal = (data: IProviderReport[]) => {
    let groupData: any = {};
    let total1 = 0;
    let total2 = 0;
    let total3 = 0;
    let total4 = 0;
    let total5 = 0;
    let total6 = 0;
    let total7 = 0;
    let total8 = 0;
    let total9 = 0;
    let total10 = 0;
    let total11 = 0;
    let total12 = 0;
    let total13 = 0;
    let total14 = 0;
    data.forEach((it) => {
        total1 += it.totalHoursWorked ? it.totalHoursWorked : 0;
        total2 += it.totalPayroll ? it.totalPayroll : 0;
        total3 += it.totalConfirmedAmount ? it.totalConfirmedAmount : 0;
        total14 += it.totalBonus ? it.totalBonus : 0;
        total4 += it.totalBilledAmount ? it.totalBilledAmount : 0;
        total5 += it.totalCollected ? it.totalCollected : 0;
        total6 += it.totalDue ? it.totalDue : 0;
        total7 += it.salaryTotal ? it.salaryTotal : 0;
        total8 += it.totalPayrollLeft ? it.totalPayrollLeft : 0;
        total9 += it.totalBilledPaidAmount ? it.totalBilledPaidAmount : 0;
        total10 += it.totalBilledDueAmount ? it.totalBilledDueAmount : 0;
        total11 += it.adminWorkTotal ? it.adminWorkTotal : 0;
        total12 += it.internalTotal ? it.internalTotal : 0;
        total13 += it.totalWrittenOffAmount ? it.totalWrittenOffAmount : 0;
    });
    groupData = {
        id: ``,
        totalRow: true,
        totalHoursWorked: total1,
        totalBonus: total14,
        adminWorkTotal: total11,
        internalTotal: total12,
        totalPayroll: total2,
        totalConfirmedAmount: total3,
        totalBilledAmount: total4,
        totalCollected: total5,
        totalDue: total6,
        totalWrittenOffAmount: total13,
        salaryTotal: total7,
        totalPayrollLeft: total8,
        totalBilledPaidAmount: total9,
        totalBilledDueAmount: total10,
    };

    return groupData;
};
